const SCOPE = 'form-generator';

export const FormGeneratorTestIds = {
  GROUP_DELETE_BUTTON: `${SCOPE}.group-delete-button`,
  GROUP_EDIT_CONTROL_BUTTON: `${SCOPE}.group-edit-control-button`,
  GROUP_DELETE_CONTROL_BUTTON: `${SCOPE}.group-delete-control-button`,
};

export const getCheckboxGroupOptionTestId = optionValue =>
  `${SCOPE}.checkbox-group-option-${optionValue}`;
